import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import { HomePage } from './pages/HomePage';
// import { SkyPage } from './pages/SkyPage';
// import { SeeYourSkyPage } from './pages/SeeYourSkyPage';
import './App.css';

function App() {
  return (
    <Router>
      <Routes> 
        <Route path="/" element={<div>Hello World</div>} />
        {/* <Route path="/" element={<HomePage />} /> */}
        {/* <Route path="/see-your-sky" element={<SeeYourSkyPage />} /> */}
        {/* <Route path="/:month/:day" element={<SkyPage />} /> */}
      </Routes>
    </Router>
  );
}

export default App;
